import React from 'react'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { BoxProps } from '@mui/material/Box'

type PaddingSize = '0' | 'small' | 'medium' | 'large'

interface CopyProps {
  maxWidth?: 'sm' | 'md' | 'lg' | false
  children: React.ReactNode
  sx?: BoxProps['sx']

  // same padding control as CopyContainer
  padding?:
    | PaddingSize
    | {
        top?: PaddingSize
        right?: PaddingSize
        bottom?: PaddingSize
        left?: PaddingSize
      }
  topBottom?: boolean
  leftRight?: boolean
  noRightPadding?: boolean
  lineHeight?: '0' | 'small' | 'medium' | 'large'
  stackSpacing?: '0' | 'small' | 'medium' | 'large'
}

// spacing / line height
const copyDensity = {
  ['0']: {
    lineHeight: 0,
    stackSpacing: 0,
  },
  small: {
    lineHeight: 0.75,
    stackSpacing: 1,
  },
  medium: {
    lineHeight: 1.6,
    stackSpacing: 3,
  },
  large: {
    lineHeight: 1.75,
    stackSpacing: 5,
  },
}

const Copy: React.FC<CopyProps> = ({
  maxWidth = 'md',
  children,
  sx,
  lineHeight = '0',
  stackSpacing = '0',
}) => {
  return (
    <Container
      maxWidth={maxWidth}
      sx={{
        padding: 0,
        lineHeight: copyDensity[lineHeight].lineHeight,
        boxSizing: 'border-box',
        ...sx,
      }}
    >
      <Stack spacing={copyDensity[stackSpacing].stackSpacing}>{children}</Stack>
    </Container>
  )
}

export default Copy
